import { render } from "./ConversationMessage.vue?vue&type=template&id=ad4a8336&scoped=true"
import script from "./ConversationMessage.vue?vue&type=script&lang=js"
export * from "./ConversationMessage.vue?vue&type=script&lang=js"

import "./ConversationMessage.vue?vue&type=style&index=0&id=ad4a8336&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ad4a8336"

export default script